import React, { PureComponent } from 'react';
import Icon from 'widgets/Icon/Icon';

export default class BopAgeRestriction extends PureComponent {
  render() {
    return (
      <div className="bop-ageRestriction">
        <div className="bop-ageRestriction__upper">
          <Icon name="age-restriction" />
          <span className="bop-ageRestriction__title">This product is age restricted to 18 years or over</span>
        </div>
        <div className="bop-ageRestriction__lower">
          <div>You&apos;ll be asked to confirm that you are over 18 on delivery.</div>
        </div>
      </div>
    );
  }
}
